import { render, staticRenderFns } from "./Angeles.vue?vue&type=template&id=7bf89370&"
import script from "./Angeles.vue?vue&type=script&lang=js&"
export * from "./Angeles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports